export default "__VITE_ASSET__DsePdNtS__"